<div class="modal-container">
  <div class="modal-header">
    <div class="header-title">
      <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
      <h2>Generate Energy Report</h2>
    </div>
    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <!-- Site Selection -->
    <div class="form-row">
      <label>Site Context</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [(value)]="selectedSite" (selectionChange)="onSiteChange()">
          <mat-option *ngFor="let site of sitesList" [value]="site">
            {{ site.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Period / Report Scope Selection -->
    <div class="form-row split">
      <div class="form-group">
        <label>Report Scope</label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [(value)]="selectedScope" (selectionChange)="onScopeChange()">
            <mat-option *ngFor="let s of scopes" [value]="s">
              {{ s }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Year Selector for pre-defined chunks -->
      <div class="form-group" *ngIf="selectedScope !== 'Custom Date Range'">
        <label>Year</label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [(value)]="selectedYear" (selectionChange)="onYearChange()">
            <mat-option *ngFor="let y of years" [value]="y">
              {{ y }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Quarter / Month Selectors -->
    <div class="form-row" *ngIf="selectedScope === 'Quarterly Report'">
      <label>Quarter</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [(value)]="selectedQuarter">
          <mat-option *ngFor="let q of quarters" [value]="q.value">
            {{ q.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row" *ngIf="selectedScope === 'Monthly Report'">
      <label>Month</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [(value)]="selectedMonth">
          <mat-option *ngFor="let m of months" [value]="m.value">
            {{ m.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Custom Date Range picker -->
    <div class="form-row split" *ngIf="selectedScope === 'Custom Date Range'">
      <div class="form-group">
        <label>Start Date</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-group">
        <label>End Date</label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <!-- Comparison Options Section -->
    <div class="section-title">
      <h3>Comparison Options</h3>
    </div>
    <div class="form-row">
      <label>Comparison Mode</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select [(value)]="selectedComparisonMode">
          <ng-container *ngFor="let mode of comparisonModes">
            <mat-option *ngIf="mode.scopes.includes(selectedScope)" [value]="mode.value">
              {{ mode.label }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="modal-footer">
    <button mat-button class="cancel-btn" (click)="onClose()">Cancel</button>
    <button mat-flat-button color="primary" class="generate-btn" (click)="generateReport()" [disabled]="!isFormValid">
      <mat-icon>download</mat-icon>
      Generate PDF
    </button>
  </div>
</div>
